import React from 'react';

const IconChevronRight = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M7.79987 4.35967C8.15343 4.06504 8.6789 4.11281 8.97354 4.46637L13.1402 9.46637C13.3977 9.77541 13.3977 10.2243 13.1402 10.5333L8.97354 15.5333C8.6789 15.8869 8.15343 15.9347 7.79987 15.64C7.4463 15.3454 7.39853 14.8199 7.69317 14.4664L11.4153 9.99986L7.69317 5.53335C7.39853 5.17978 7.4463 4.65431 7.79987 4.35967Z" fill="#36526C" />
  </svg>

);

export default IconChevronRight;
